import React, {FC} from "react";
import {
    IconButton,
    Tooltip,
    Box,
} from "@mui/material";
import {ListAlt} from "@mui/icons-material";
import {Locale} from "../../locales/Locale";
import {IdlocaGeneric} from "../../locales/IdlocaGeneric";
import {Link} from "react-router-dom";

interface IDetailsButton {
    navigateToDetailsPath: string;
    mobileMode: boolean;
}

export const DetailsButton: FC<IDetailsButton> = ({navigateToDetailsPath, mobileMode}) => {
    return (
        <Tooltip title={<Locale localeId={IdlocaGeneric.view_details}/>} arrow>
            <Box
                sx={{
                    display: "inline-block",
                    "&:hover .details-button": {opacity: 1, transform: "translateY(0)"},
                }}
            >
                <Link to={navigateToDetailsPath} style={{textDecoration: "none"}}>
                    <IconButton
                        color="primary"
                        className="details-button"
                        aria-label="view details"
                        sx={{
                            transition: "opacity 0.3s, transform 0.3s",
                            opacity: mobileMode ? 1 : 0,
                            transform: mobileMode ? "translateY(0)" : "translateY(-10px)",
                        }}
                    >
                        <ListAlt/>
                    </IconButton>
                </Link>
            </Box>
        </Tooltip>
    );
};
